// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OWO6","select":"styles_select__9Y_gZ"};